module.exports = __webpack_public_path__ + "static/media/is time waitin-01.ad089543.png";